import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";
import { PeriodUpdateRequest } from "./PeriodUpdateRequest";
import { PeriodUpdateWithTardyRequest } from "./PeriodUpdateWithTardyRequest";
import { SchoolContactUpdateRequest } from "./SchoolContactUpdateRequest";
import { SUPrefSelectRequest } from "./SUPrefSelectRequest";
import { SUPrefUpdateRequest } from "./SUPrefUpdateRequest";
import { StationPreferenceModifyRequest } from "./StationPreferenceModifyRequest";
import { SchoolPortalAppRequest } from "./school-portal-app-request";

@Injectable()
export class SchoolSettingsService {
	constructor(private httpclientService: HttpclientService) {}

	PeriodValidity(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/PeriodValidity?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SemesterValidity(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SemesterValidity?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PeriodUpdate(parms: PeriodUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/PeriodUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	PeriodUpdateWithTardy(parms: PeriodUpdateWithTardyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/PeriodUpdateWithTardy";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SemesterUpdate(SemesterID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SemesterUpdate?SemesterID=" + SemesterID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PeriodList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/PeriodList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	//
	// EF
	//

	// HomeroomGetList(schoolID) {
	//   var postResult$ = new Subject();
	//   var url = 'SchoolSettings/HomeroomGetList?schoolID=' + schoolID;

	//   var promise$ = this.httpclientService.post(url, null);
	//   promise$.subscribe(response => {
	//       postResult$.next(response);
	//   },error => {
	//       postResult$.error(error);

	//     }

	//   )
	//   return postResult$;

	// }

	//
	// EF
	//

	// GradesGetList(schoolID) {
	//   var postResult$ = new Subject();
	//   var url = 'SchoolSettings/GradesGetList?schoolID=' + schoolID;

	//   var promise$ = this.httpclientService.post(url, null);
	//   promise$.subscribe(response => {
	//       postResult$.next(response);
	//   },error => {
	//       postResult$.error(error);

	//     }

	//   )
	//   return postResult$;
	// }

	// PeriodGetList(schoolID) {
	//   var postResult$ = new Subject();
	//   var url = 'SchoolSettings/PeriodGetList?schoolID=' + schoolID;

	//   var promise$ = this.httpclientService.post(url, null);
	//   promise$.subscribe(response => {
	//       postResult$.next(response);
	//   },error => {
	//       postResult$.error(error);

	//     }

	//   )
	//   return postResult$;

	// }

	SchoolContactUpdate(parms: SchoolContactUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SchoolContactUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	AcademyGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/AcademyGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	SemesterList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SemesterList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SchoolList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	updatePreference(schoolID, category, keyName, keyVal) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/PreferenceUpdateByKeyVal?SchoolID=" + schoolID + "&Category=" + category + "&KeyName=" + keyName + "&KeyVal=" + keyVal;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadPreferenceListByCategory(schoolID, category) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/PreferenceListByCategory?SchoolID=" + schoolID + "&Category=" + category;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateFeeFine(applicationID, schoolID, replaceFee, tempFee, chargeTempFee) {
		var postResult$ = new Subject();
		var url =
			"SchoolSettings/UpdateFeeFine?ApplicationID=" +
			applicationID +
			"&SchoolID=" +
			schoolID +
			"&ReplaceIDCardFee=" +
			replaceFee +
			"&TemporaryIDFee=" +
			tempFee +
			"&ChangeTemporaryIDFee=" +
			chargeTempFee;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateAttendancePref(applicationID, schoolID, usePartial, PartialPercent, PercentForSchoolDay) {
		var postResult$ = new Subject();
		var url =
			"SchoolSettings/UpdateAttendancePref?ApplicationID=" +
			applicationID +
			"&SchoolID=" +
			schoolID +
			"&UsePartial=" +
			usePartial +
			"&PartialPercent=" +
			PartialPercent +
			"&PercentForSchoolDay=" +
			PercentForSchoolDay;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateSchoolEmail(applicationID, schoolID, providerName, providerInfo, makeDefault, definedBy, deleteAccounts) {
		var postResult$ = new Subject();
		var url =
			"SchoolSettings/UpdateSchoolEmail?ApplicationID=" +
			applicationID +
			"&SchoolID=" +
			schoolID +
			"&EmailProviderName=" +
			providerName +
			"&EmailProviderEmailInfo=" +
			providerInfo +
			"&IsPrimary=" +
			makeDefault +
			"&DefinedBy=" +
			definedBy +
			"&DeleteAccountEmails=" +
			deleteAccounts;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateCalendar(applicationID, schoolID, DayType, SkipClosed, UseBell, AdjustWhenClosed) {
		var postResult$ = new Subject();
		var url =
			"SchoolSettings/UpdateCalendar?ApplicationID=" +
			applicationID +
			"&SchoolID=" +
			schoolID +
			"&DayType=" +
			DayType +
			"&SkipClosed=" +
			SkipClosed +
			"&UseBell=" +
			UseBell +
			"&AdjustWhenClosed=" +
			AdjustWhenClosed;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateAdmin(applicationID, schoolID, chkAdmin, chkAdvisor, chkStaff, chkMultiSchoolStaff, chkTeacher) {
		var postResult$ = new Subject();
		var url =
			"SchoolSettings/UpdateAdmin?ApplicationID=" +
			applicationID +
			"&SchoolID=" +
			schoolID +
			"&chkAdmin=" +
			chkAdmin +
			"&chkAdvisor=" +
			chkAdvisor +
			"&chkStaff=" +
			chkStaff +
			"&chkMultiSchoolStaff=" +
			chkMultiSchoolStaff +
			"&chkTeacher=" +
			chkTeacher;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateAdminEmail(applicationID, schoolID, EmailSig) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/UpdateAdminEmail?ApplicationID=" + applicationID + "&SchoolID=" + schoolID + "&EmailSig=" + EmailSig;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateAssumedPresent(applicationID, schoolID, AssumedPresent) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/UpdateAssumedPresent?ApplicationID=" + applicationID + "&SchoolID=" + schoolID + "&AssumedPresent=" + AssumedPresent;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateDetentionSettings(applicationID, schoolID, DetentionScanning, TardiesGenDetention, CreateDeten) {
		var postResult$ = new Subject();
		var url =
			"SchoolSettings/UpdateDetentionSettings?ApplicationID=" +
			applicationID +
			"&SchoolID=" +
			schoolID +
			"&DetentionScanning=" +
			DetentionScanning +
			"&TardiesGenDetention=" +
			TardiesGenDetention +
			"&CreateDeten=" +
			CreateDeten;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadCategoryList(applicationID, schoolID, userID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/LoadCategoryList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID + "&UserID=" + userID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CategorySelectAll() {
		var postResult$ = new Subject();
		var url = "SchoolSettings/CategorySelectAll?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadPrefKeyList(applicationID, schoolID, userID, category, filter) {
		var postResult$ = new Subject();
		var url =
			"SchoolSettings/LoadPrefKeyList?ApplicationID=" +
			applicationID +
			"&SchoolID=" +
			schoolID +
			"&UserID=" +
			userID +
			"&Category=" +
			category +
			"&Filter=" +
			filter;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadSUPrefList(applicationID, schoolID, userID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/LoadSUPrefDataList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID + "&UserID=" + userID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadScanStationSoundList(applicationID, schoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/LoadScanStationSoundList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadDUSSPList(applicationID, schoolID, userID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/LoadDUSSPList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID + "&UserID=" + userID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadSSPList(applicationID, schoolID, userID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/LoadSSPList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID + "&UserID=" + userID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadPenaltyList(applicationID, schoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/LoadPenaltyList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationSettingsExcuseSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/ScanStationSettingsExcuseSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateScanStationPrefDU(parms: StationPreferenceModifyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/UpdateScanStationPrefDU?";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateScanStationPref(parms: StationPreferenceModifyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/UpdateScanStationPref?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteSound(applicationID, soundID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/DeleteSound?ApplicationID=" + applicationID + "&SoundLibraryID=" + soundID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadEmailList(applicationID, userID, schoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/LoadEmailList?ApplicationID=" + applicationID + "&UserID=" + userID + "&SchoolID=" + schoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadSoundFile(applicationID, soundLibraryID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/LoadSoundFile?ApplicationID=" + applicationID + "&SoundLibraryID=" + soundLibraryID;

		var promise$ = this.httpclientService.getSoundFile(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SUPrefModify(PreferenceID, KeyVal) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SUPrefModify?PreferenceID=" + PreferenceID + "&KeyVal=" + KeyVal;
		var promise$ = this.httpclientService.getSoundFile(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SUPrefUpdate(parms: SUPrefUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SUPrefUpdate";
		var promise$ = this.httpclientService.getSoundFile(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SUPreferenceSelectList(parms: SUPrefSelectRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SUPreferenceSelectList";
		var promise$ = this.httpclientService.getSoundFile(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolMFASettingSelect(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SchoolMFASettingSelect?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.getSoundFile(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateSchoolMFA(SchoolID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/SchoolMFAUpdate?SchoolID=" + SchoolID + "&ChangeTo=" + ChangeTo;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateSecuritySettings(SchoolID, LockAccountAfterDays) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/UpdateSecuritySettings?SchoolID=" + SchoolID + "&LockAccountAfterDays=" + LockAccountAfterDays;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationPassOptionSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/StationPassOptionSelectList?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PortalAppSettingsSelect(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/PortalAppSettingsSelect?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PortalAppDailyAbsentNotificationScheduleModify(parms: SchoolPortalAppRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/PortalAppDailyAbsentNotificationScheduleModify";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
